import React, { useState } from 'react';
import { useAdmin } from '../../contexts/AdminContext';
import { Navigate } from 'react-router-dom';

function AdminLogin() {
  const { login, isAuthenticated, loading } = useAdmin();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Redirect if already authenticated
  if (isAuthenticated && !loading) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    console.log('Login attempt with:', formData);
    const result = await login(formData);
    console.log('Login result:', result);
    
    if (!result.success) {
      setError(result.error);
      setSubmitting(false);
    } else {
      // Force navigation to admin dashboard
      console.log('Login successful, redirecting to dashboard');
      window.location.href = '/admin/dashboard';
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-3">Checking authentication...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login">
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-md-6 col-lg-4">
            <div className="login-card">
              {/* Logo and Header */}
              <div className="text-center mb-4">
                <img 
                  src="/logo192.png" 
                  alt="Cioconat" 
                  className="login-logo mb-3"
                  style={{ width: '80px', height: '80px' }}
                />
                <h2 className="login-title">Cioconat CMS</h2>
                <p className="text-muted">Admin Portal</p>
              </div>

              {/* Login Form */}
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    placeholder="Enter your username"
                    autoComplete="username"
                  />
                </div>

                <div className="form-group mb-4">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="Enter your password"
                    autoComplete="current-password"
                  />
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Signing in...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-sign-in-alt me-2"></i>
                      Sign In
                    </>
                  )}
                </button>
              </form>


              {/* Footer */}
              <div className="text-center mt-4">
                <small className="text-muted">
                  Cioconat Restaurant Management System
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .admin-login {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
        }

        .login-card {
          background: white;
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border: none;
        }

        .login-logo {
          border-radius: 50%;
          object-fit: cover;
        }

        .login-title {
          color: #333;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .form-control {
          border-radius: 8px;
          border: 2px solid #e9ecef;
          padding: 0.75rem 1rem;
          transition: all 0.3s ease;
        }

        .form-control:focus {
          border-color: #c9302c;
          box-shadow: 0 0 0 0.2rem rgba(201, 48, 44, 0.25);
        }

        .btn-primary {
          background-color: #c9302c;
          border-color: #c9302c;
          border-radius: 8px;
          padding: 0.75rem 1rem;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          background-color: #a02622;
          border-color: #a02622;
          transform: translateY(-1px);
        }

        .alert {
          border-radius: 8px;
          margin-bottom: 1rem;
        }

        .admin-loading {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        @media (max-width: 768px) {
          .login-card {
            margin: 1rem;
            padding: 1.5rem;
          }
        }
      `}</style>
    </div>
  );
}

export default AdminLogin;